var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 105,
    viewBox: "0 0 152 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.4768 23.28C58.4768 21.47 59.9468 20 61.7468 20H114.157C115.967 20 117.427 21.47 117.427 23.28V24.33C117.427 30.96 112.047 36.34 105.417 36.34H70.4768C63.8468 36.34 58.4668 30.96 58.4668 24.33V23.28H58.4768Z",
    fill: "#E5726A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.647 32.2695H74.2574C72.3354 32.2695 70.7773 33.8276 70.7773 35.7495V72.0696C70.7773 73.9915 72.3354 75.5496 74.2574 75.5496H101.647C103.569 75.5496 105.127 73.9915 105.127 72.0696V35.7495C105.127 33.8276 103.569 32.2695 101.647 32.2695Z",
    fill: "#E5726A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5176 55.2703C79.5176 53.6403 80.8375 52.3203 82.4675 52.3203C84.0975 52.3203 85.4175 53.6403 85.4175 55.2703V75.5603H79.5176V55.2703Z",
    fill: "#C25148"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4863 55.2703C90.4863 53.6403 91.8063 52.3203 93.4363 52.3203C95.0663 52.3203 96.3864 53.6403 96.3864 55.2703V75.5603H90.4863V55.2703Z",
    fill: "#C25148"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9863 35.3799H106.936C109.696 35.3799 111.936 37.6199 111.936 40.3799C111.936 43.1399 109.696 45.3799 106.936 45.3799H68.9863C66.2263 45.3799 63.9863 43.1399 63.9863 40.3799C63.9863 37.6199 66.2263 35.3799 68.9863 35.3799Z",
    fill: "#FFB443"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardHistory);
export default __webpack_public_path__ + "static/media/card_history.5012510e9dba42686fe0c998919d67c4.svg";
export { ForwardRef as ReactComponent };